import type { SupportBaseInvoice } from "@redotech/redo-billing-common/service-invoice";
import { supportBaseInvoiceSchema } from "@redotech/redo-billing-common/service-invoice";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export interface GetSupportInvoicesOutput {
  invoices: SupportBaseInvoice[];
}

const getSupportInvoicesOutput_: z.ZodType<GetSupportInvoicesOutput> = z.object(
  { invoices: z.array(supportBaseInvoiceSchema) },
);

export const getSupportInvoices: {
  name: "getSupportInvoices";
  input: z.ZodObject<{ teamId: z.ZodType<string> }>;
  output: z.ZodType<GetSupportInvoicesOutput>;
} = {
  name: "getSupportInvoices" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: getSupportInvoicesOutput_,
};
